import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import FeatureValue from './FeatureValue';

interface Feature {
  name: string;
  description?: string;
  starter: any;
  max: any;
  family: any;
  familyPlus?: any;
  careAddOn?: any;
}

interface FeatureRowProps {
  feature: Feature;
}

const FeatureRow = ({ feature }: FeatureRowProps) => {
  return (
    <div className="grid grid-cols-4 gap-2 p-3 rounded-lg hover:bg-muted/20 transition-colors">
      <div className="text-sm font-medium text-foreground flex items-center gap-2">
        <span className="text-xs lg:text-sm">{feature.name}</span>
        {feature.description && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button 
                className="w-4 h-4 text-muted-foreground hover:text-foreground cursor-help touch-manipulation flex-shrink-0"
                type="button"
                aria-label="Feature information"
              >
                <InformationCircleIcon className="w-4 h-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs z-50 bg-popover border shadow-lg">
              <p className="text-sm">{feature.description}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      {/* 3 Plan Columns */}
      <div className="flex justify-center items-center text-center">
        <FeatureValue value={feature.starter} />
      </div>
      <div className="flex justify-center items-center text-center">
        <FeatureValue value={feature.max} />
      </div>
      <div className="flex justify-center items-center text-center">
        <FeatureValue value={feature.family} />
      </div>
    </div>
  );
};

export default FeatureRow;
